import { IFormBuilderForm, TFormBuilderFormSettings } from "../../model/formBuilderForm";

export interface IUpdateFormSettingsActionPayload {
  prevFormSettings: TFormBuilderFormSettings;
  nextFormSettings: TFormBuilderFormSettings;
}

export interface IUpdateFormSettingsAction {
  type: "UPDATE_FORM_SETTINGS";
  payload: IUpdateFormSettingsActionPayload;
}

export function getUpdateFormSettingsInverseAction(
  action: IUpdateFormSettingsAction,
): IUpdateFormSettingsAction {
  return {
    type: "UPDATE_FORM_SETTINGS",
    payload: {
      prevFormSettings: action.payload.nextFormSettings,
      nextFormSettings: action.payload.prevFormSettings,
    },
  };
}

export function applyUpdateFormSettingsChange(
  form: IFormBuilderForm,
  action: IUpdateFormSettingsAction,
): IFormBuilderForm {
  return {
    ...form,
    settings: {
      ...action.payload.nextFormSettings,
    },
  };
}
